import request from '@/utils/request'


export function getCode(data) {
console.log('getcode',data)
  return request({
    url: 'common/getCode',
    method: 'get',
    params: data
  })
}

export function register(data) {
  return request({
    url: 'common/register',
    method: 'post',
    data: data
  })
}

export function resetPwd(data) {
  return request({
    url: 'common/resetPwd',
    method: 'post',
    data: data
  })
}


export function login(data) {
  return request({
    url: 'common/login',
    method: 'post',
    data: data
  })
}

export function logout(data) {
  return request({
    url: 'common/logout',
    method: 'post',
    data: data
  })
}
